import { useDesignMaxTheme } from "@/packages";
import { FONT } from "@/styles";
import { Box, Center, Grid, Spinner, Text } from "@chakra-ui/react";
import { useGetReserve, type ReserveRoomResponse } from "@shared/server";

export const RoomModalContent = ({ roomIdx, roomName }: { roomIdx: number; roomName: string }) => {
    const { data } = useGetReserve<ReserveRoomResponse>({ section: "view", roomIdx });
    const { COLORS, MEDIAS } = useDesignMaxTheme();
    const { isTablet, isMobile } = MEDIAS();
    const tabletBoxHeight = isTablet ? "300px" : "360px";

    const wrapperPCWidth = isTablet ? "480px" : "720px";
    return (
        <Box
            overflow="auto"
            position="relative"
            width={isMobile ? "320px" : wrapperPCWidth}
            h="640px"
            borderRadius="16px"
        >
            <Text
                position="sticky"
                top="0"
                p="16px 24px"
                as="h4"
                {...FONT("pretendard", 24, 500)}
                color={COLORS.white}
                background={COLORS.blue[300]}
            >
                {roomName}
            </Text>
            {data ? (
                <Grid w="100%" gridTemplateColumns="repeat(2, 1fr)" gridGap="4px">
                    {data.imgList.map((img) => (
                        <Box
                            key={img.imgUrl}
                            w="100%"
                            h={isMobile ? "160px" : tabletBoxHeight}
                            background={`url(${img.imgUrl}) no-repeat center/cover`}
                        ></Box>
                    ))}
                </Grid>
            ) : (
                <Center h="100%">
                    {/* 스피너 위치 처리 */}
                    <Spinner />
                </Center>
            )}
        </Box>
    );
};
